import React, { Component } from 'react';
import { selectAll } from 'd3-selection';
import { newSvg, chart, plot, color } from 'dimple';

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  drawViz(props) {
    const data = props.data;
    let svg = newSvg(this.myRef.current, 580, 270);
    let myChart = new chart(svg, data);
    myChart.setBounds(80, 30, 480, 200);
    myChart.defaultColors = [
      new color('#1890ff', 1),
      new color('#01665e', 1),
      new color('#5ab4ac', 1),
      new color('#c7eae5', 1),
      new color('#f5f5f5', 1),
      new color('#f6e8c3', 1),
      new color('#d8b365', 1),
      new color('#8c510a', 1),
      new color('#3498db', 1)
    ];
    const x = myChart.addCategoryAxis('x', ['day', 'region']);
    x.addOrderRule('serviceDate');
    const y1 = myChart.addMeasureAxis('y', 'booked');
    const y2 = myChart.addMeasureAxis('y', 'available');
    const maxAvail = data
      .map(el => parseInt(el['available']))
      .sort((a, b) => b - a)[0];
    const maxBooked = data
      .map(el => parseInt(el['booked']))
      .sort((a, b) => b - a)[0];
    const maxHeight = maxBooked > maxAvail ? maxBooked : maxAvail;
    y1.overrideMax = maxHeight + 20;
    y2.overrideMax = maxHeight + 20;
    //for dimple series each one has its own axis, since booked and available all use hours
    // want to set max scale for each.
    const colorAxis = myChart.addColorAxis('available', ['#e8e8e8', '#e8e8e8']);
    colorAxis.tickFormat = '.2f';
    myChart.addSeries('available', plot.bar, [x, y2, colorAxis]);
    myChart.addSeries('region', plot.bar, [x, y1]);
    x.title = '';
    y1.title = 'Hours';
    y2.hidden = true;
    y1.tickFormat = '.2f';
    y2.tickFormat = '.2f';
    //append title
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec'
    ];
    const startDate = new Date(data[0].serviceDate);
    const endDate = new Date(data[data.length - 1].serviceDate);
    const region =
      data[0].region == null ? 'No Region Assigned' : `${data[0].region} Hours`;
    const title = `${region} for ${
      monthNames[startDate.getUTCMonth()]
    } ${startDate.getUTCDate()} - ${
      monthNames[endDate.getUTCMonth()]
    } ${endDate.getUTCDate()}`;
    svg
      .append('text')
      .attr('x', 320)
      .attr('y', 15)
      .attr('text-anchor', 'middle')
      .style('font-size', '20px')
      .text(title);
    myChart.draw();
    selectAll('.dimple-custom-axis-label')
      .style('text-transform', 'capitalize')
      .style('font-size', '14px');
    x.titleShape.style('font-size', '16px');
    y1.titleShape.style('font-size', '16px').attr('y', 115);
  }

  componentDidMount() {
    try {
      this.drawViz(this.props);
    } catch (err) {
      console.log(err); // eslint-disable-line no-console
    }
  }

  render() {
    return (
      <>
        <div ref={this.myRef}></div>
      </>
    );
  }
}

export default BarChart;
